import axios from 'axios';

import { getNoCache } from 'utils/NoCacheUtils';

import { Enviroment, EnvInitCallback } from './interfaces';

import { ApiName } from 'enuns/Api';

class Env {
  private _config: Enviroment | null = null;

  private async fetch() {
    try {
      const response = await axios.get<Enviroment>(`assets/environments/default.json?noCache=${getNoCache()}`);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  private set config(value: Enviroment | null) {
    this._config = value;
  }

  private get config() {
    return this._config;
  }

  public api(name: ApiName) {
    switch (name) {
      case ApiName.Assessor:
        return this.config?.apis.assessor || '';
      case ApiName.Evento:
        return this.config?.apis.evento || '';
      case ApiName.Messenger:
        return this.config?.apis.messenger || '';
      case ApiName.Notificacao:
        return this.config?.apis.notificacao || '';
      case ApiName.Pessoa:
        return this.config?.apis.pessoa || '';
      default:
        return '';
    }
  }

  public get name() {
    return this.config?.environment;
  }

  public get hasConfig() {
    return Boolean(this.config);
  }

  public get wsEndpoint() {
    return this.config?.websockets.wsAssembleia || '';
  }

  public get isOffline() {
    return this.config?.isOffline;
  }

  public get auth() {
    return this.config?.auth;
  }

  public async init(callback: EnvInitCallback) {
    const env = await this.fetch();
    this.config = env;
    callback();
  }
}

export default new Env();
